import {
  DrawerFooterArea,
  Drawer as DrawerType,
  ControlcenterMelcoModelsLicenseCreateResponse,
} from "melco-shared-logic";
import {
  Col,
  Drawer,
  FullWidthSpace,
  Row,
  Steps,
  DesignTokens,
} from "melco-ui";
import {
  CreateLicenseForm,
  CreateLicenseFormValueType,
} from "../form/CreateLicenseForm";
import { useState } from "react";
import { CreateLicenseSummary } from "../form/CreateLicenseSummary";
import { CopyLicense } from "../form/CopyLicense";
import { useTranslation } from "react-i18next";

const { spacings } = DesignTokens;

type CreateLicenseDrawerProps = {
  drawer: DrawerType;
};

export const CreateLicenseDrawer: React.FC<CreateLicenseDrawerProps> = ({
  drawer,
}) => {
  const { t } = useTranslation();
  const { closeDrawer, isDrawerOpen } = drawer;
  const [currentStep, setCurrentStep] = useState(0);
  const [licenseFormValues, setLicenseFormValues] =
    useState<CreateLicenseFormValueType>();
  const [licenseDisplayValues, setLicenseDisplayValues] = useState<any>();
  const [createLicenseResponse, setCreateLicenseResponse] =
    useState<ControlcenterMelcoModelsLicenseCreateResponse>();
  const onCloseDrawer = () => {
    setCurrentStep(0);
    setLicenseFormValues({
      product_code: "",
      subscription_code: "",
      version_id: "",
      email_address: "",
      version_number: "",
      language: "",
      melco_customer_id: "",
      affiliate_code: ""
    });
    setLicenseDisplayValues({
      subscription_code_label: "",
      product_code_label: "",
      version_number_label: "",
      language: "",
    });
    closeDrawer();
  };

  const callBackStep2Fn = (
    obj: ControlcenterMelcoModelsLicenseCreateResponse | undefined
  ) => {
    console.log(obj);
    setCreateLicenseResponse(obj);
    setCurrentStep(currentStep + 1);
  };

  const stepback = () => {
    setCurrentStep(currentStep - 1);
  };

  const callBackStep1Fn = (
    values: CreateLicenseFormValueType,
    displayValues: any
  ) => {
    setLicenseFormValues(values);
    setCurrentStep(currentStep + 1);
    setLicenseDisplayValues(displayValues);
  };

  const forms: any = [
    <CreateLicenseForm
      onCreateLicenseCallBackFn={callBackStep1Fn}
      licenseFormValues={licenseFormValues}
      licenseDisplayValues={licenseDisplayValues}
    />,

    <CreateLicenseSummary
      stepback={stepback}
      callbackFn={callBackStep2Fn}
      licenseFormValues={licenseFormValues}
      licenseDisplayValues={licenseDisplayValues}
    />,

    <CopyLicense
      successMessage={t("licensemanager.create.copy.message").replace(
        "[email]",
        licenseFormValues?.email_address ?? ""
      )}
      createLicenseResponse={createLicenseResponse}
      onCloseDrawer={onCloseDrawer}
      licenseFormvalues={licenseFormValues}
      title={t("licensemanager.create.copy.title")}
    />,
  ];

  // isDrawerOPen is used multiple times to display UI, basically to refresh DOM and build components in DOM again
  // As Footer section was becoming empty if go from one Drawer to other like Create Drawer, Upgrade Drawer, Change Level Drawer

  return (
    <>
      {isDrawerOpen && (
        <Drawer
          title={t("licensemanager.create.drawertitle")}
          placement="right"
          width={1000}
          closable={true}
          onClose={onCloseDrawer}
          open={isDrawerOpen}
          footer={isDrawerOpen && <DrawerFooterArea />}
        >
          <FullWidthSpace direction="vertical">
            <Steps
              items={[
                {
                  title: t("licensemanager.create.steps.licensedetail"),
                },

                {
                  title: t("licensemanager.create.steps.summary"),
                },
                {
                  title: t("licensemanager.create.steps.copylicense"),
                },
              ]}
              current={currentStep}
              labelPlacement="vertical"
              size="small"
            />

            <FullWidthSpace direction="vertical" size="middle">
              {/* <Title level={4}>Define customer & license details</Title> */}

              <div>
                <Row gutter={[spacings.middle, 0]}>
                  <Col xs={24} md={24}>
                    {isDrawerOpen && forms[currentStep]}
                  </Col>
                </Row>
              </div>
            </FullWidthSpace>
          </FullWidthSpace>
        </Drawer>
      )}
    </>
  );
};
